import React, { Component } from 'react';
// Material UI
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
// import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import Snackbar from '@material-ui/core/Snackbar';
import { Close, CheckCircle, Error, ExitToApp, Security } from '@material-ui/icons';

// Icons
import { Announcement, ExpandLess, ExpandMore, NetworkCheck, Layers, Search, Category, Assessment, Help, ArrowDropDown, ArrowDropUp } from '@material-ui/icons';


class Header extends Component {
    constructor(props) {
        super(props);
        this.changeMenuStatus = this.changeMenuStatus.bind(this);
        this.handleAdicionalesClick = this.handleAdicionalesClick.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleTiposClick = this.handleTiposClick.bind(this);
        this.handleReportesClick = this.handleReportesClick.bind(this);
        this.handleAyudaClick = this.handleAyudaClick.bind(this);
        this.changeMapType = this.changeMapType.bind(this);
        this.toggleLTE = this.toggleLTE.bind(this);
        this.toggleFTTH = this.toggleFTTH.bind(this);
        this.toggleAdquirida = this.toggleAdquirida.bind(this);
        this.toggleHFC = this.toggleHFC.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.sendData = this.sendData.bind(this);
        this.sendCPData = this.sendCPData.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseError = this.handleCloseError.bind(this);
        this.handleCloseCP = this.handleCloseCP.bind(this);
        this.toggleCPModal = this.toggleCPModal.bind(this);

        this.state = {
            contrasena: "",
            showMenu: false,
            openAdicionales: false,
            openSearch: false,
            openTipos: false,
            openReportes: false,
            openAyuda: false,
            showModal: false,
            showCPModal: false,
            name: "",
            address: "",
            email: "",
            phone: "",
            comments: "",
            open: false,
            openError: false
        };

    }

    //Open Change password Modal#######################################################################
    toggleCPModal() {
        this.setState({ showCPModal: !this.state.showCPModal });
    };
    //Open Change password Modal#######################################################################

    //Handle close of the snack########################################################################
    handleClose = (e, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    };
    //Handle close of the snack########################################################################

    //Handle close of the snack########################################################################
    handleCloseCP = (e, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ openCP: false });
    };
    //Handle close of the snack########################################################################

    //Handle close of the snack Error##################################################################
    handleCloseError = (e, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ openError: false });
    };
    //Handle close of the snack Error##################################################################

    resetForm() {
        this.setState({
            name: "",
            address: "",
            email: "",
            phone: "",
            comments: ""
        });
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    // Búsqueda Click
    handleSearchClick() {
        this.setState({ openSearch: !this.state.openSearch });
    }
    // Adicionales Click
    handleAdicionalesClick() {
        this.setState({ openAdicionales: !this.state.openAdicionales });
    }
    //Tipos Click
    handleTiposClick() {
        this.setState({ openTipos: !this.state.openTipos });
    };
    //Reportes Click
    handleReportesClick() {
        this.setState({ openReportes: !this.state.openReportes });
    };
    //Ayuda Click
    handleAyudaClick() {
        this.setState({ openAyuda: !this.state.openAyuda });
    };

    // Change the menu status
    changeMenuStatus() {
        this.setState({ showMenu: !this.state.showMenu });
    }

    //Change Map Type
    changeMapType(mapType) {
        this.props.changeMapType(mapType);
        this.changeMenuStatus();
    }
    //Toggle modal display
    toggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }
    //Toggle LTE layers
    toggleLTE() {
        this.props.toggleLTE();
        this.changeMenuStatus();
    }
    //Toggle FTTH layers
    toggleFTTH() {
        this.props.toggleFTTH();
        this.changeMenuStatus();
    }
    //Toggle Adquirida layer
    toggleAdquirida() {
        this.props.toggleAdquirida();
        this.changeMenuStatus();
    }
    //Toggle HFC layer
    toggleHFC() {
        this.props.toggleHFC();
        this.changeMenuStatus();
    }

    // Formulario de envios de datos para nuevas coberturas
    sendData() {
        let s = this.state;
        let t_ = this;
        if (s.name !== "" && s.address !== "" && s.email !== "" && s.phone !== "" && s.comments !== "" && this.props.fLat !== "" && this.props.fLon !== "") {
            axios.post(
                this.props.url + "save_client_data",
                {
                    name: s.name,
                    address: s.address,
                    email: s.email,
                    phone: s.phone,
                    comments: s.comments,
                    lat: this.props.fLat,
                    lon: this.props.fLon,
                    user: localStorage.getItem('tigoID')
                }
            )
                .then(function (response) {
                    if (response.data) {
                        t_.resetForm();
                        t_.toggleModal();
                        t_.setState({ open: true });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            t_.setState({ openError: true });
        }
    }

    // Change password on the server
    sendCPData(op) {
        let s = this.state;
        let t_ = this;
        if (s.contrasena !== "") {
            axios.post(
                this.props.url + "change_pass",
                {
                    contrasena: s.contrasena,
                    id: localStorage.getItem('tigoID')
                }
            )
                .then(function (response) {
                    t_.setState({ contrasena: "" });
                    if (op === 1) {
                        if (response.data) {
                            t_.toggleCPModal();
                            t_.setState({ openCP: true });
                        }
                    } else {
                        t_.props.forceOff();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } else {
            t_.setState({ openError: true });
        }
    }

    render() {
        // We check if the user is logged in
        if (!this.props.isLoggedIn) {
            return <div></div>;
        }

        //Modal Cobertura
        let modal = "";
        if (this.state.showModal) {
            modal = (
                <Modal
                    open={this.state.showModal}
                >
                    <div className="modal">
                        <h6 id="modal-title">
                            Coordenadas
                        </h6>
                        <div className="send-form">
                            <div className="half-input">
                                <TextField
                                    id="outlined-latitud"
                                    label="Latitud"
                                    margin="normal"
                                    helperText="Se llena al dar click en el mapa"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    defaultValue={this.props.fLat}
                                    required
                                />
                            </div>
                            <div className="half-input">
                                <TextField
                                    id="outlined-longitud"
                                    label="Longitud"
                                    margin="normal"
                                    helperText="Se llena al dar click en el mapa"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    defaultValue={this.props.fLon}
                                    required
                                />
                            </div>
                        </div>
                        <h6 id="modal-title" class="space">
                            Datos del Cliente
                        </h6>
                        <div className="send-form">
                            <div className="full-input">
                                <TextField
                                    id="outlined-name"
                                    label="Nombre completo"
                                    margin="normal"
                                    onChange={this.handleChange('name')}
                                    required
                                />
                            </div>
                            <div className="full-input">
                                <TextField
                                    id="outlined-address"
                                    label="Dirección Física"
                                    margin="normal"
                                    value={this.state.address}
                                    onChange={this.handleChange('address')}
                                    required
                                />
                            </div>
                            <div className="half-input">
                                <TextField
                                    id="outlined-email"
                                    label="Email"
                                    margin="normal"
                                    value={this.state.email}
                                    onChange={this.handleChange('email')}
                                    required
                                />
                            </div>
                            <div className="half-input">
                                <TextField
                                    id="outlined-telephone"
                                    label="Teléfono"
                                    margin="normal"
                                    value={this.state.phone}
                                    onChange={this.handleChange('phone')}
                                    required
                                />
                            </div>
                            <div className="full-input">
                                <TextField
                                    id="outlined-comments"
                                    label="Comentarios"
                                    multiline
                                    rowsMax="10"
                                    margin="normal"
                                    value={this.state.comments}
                                    onChange={this.handleChange('comments')}
                                    required
                                />
                            </div>
                        </div>
                        <div className="initial-modal-buttons">
                            <Button variant="contained" onClick={this.toggleModal}>
                                Cancelar
                            </Button>
                            <Button color="primary" variant="contained" className="guardar-informacion" onClick={this.sendData}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Modal>
            );
        }

        //Modal Change password
        let modalCP = "";
        if (this.state.showCPModal) {
            modalCP = (
                <Modal
                    open={this.state.showCPModal}
                >
                    <div className="modal">
                        <h6 id="modal-title">
                            Cambiar contraseña
                        </h6>
                        <div className="send-form">
                            <div className="full-input">
                                <TextField
                                    id="outlined-name"
                                    label="Nueva contraseña"
                                    margin="normal"
                                    onChange={this.handleChange('contrasena')}
                                    type="password"
                                    required
                                />
                            </div>
                        </div>
                        <div className="initial-modal-buttons">
                            <Button variant="contained" onClick={() => { this.toggleCPModal(); this.changeMenuStatus(); }}>
                                Cancelar
                            </Button>
                            <Button color="primary" variant="contained" className="guardar-informacion" onClick={() => this.sendCPData(1)}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Modal>
            );

        }
        //Modal Force Change password
        let modalFCP = "";
        if (this.props.force === "1") {
            modalFCP = (
                <Modal
                    open={this.props.force === "1"}
                >
                    <div className="modal">
                        <h6 id="modal-title">
                            Cambiar contraseña
                        </h6>
                        <div className="send-form">
                            <div className="full-input">
                                <TextField
                                    id="outlined-name"
                                    label="Nueva contraseña"
                                    margin="normal"
                                    onChange={this.handleChange('contrasena')}
                                    type="password"
                                    required
                                />
                            </div>
                        </div>
                        <div className="initial-modal-buttons">
                            <Button color="primary" variant="contained" className="guardar-informacion" onClick={() => this.sendCPData(2)}>
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Modal>
            );
        }

        let manualurl = `${this.props.url}../manual/manualc.pdf`;
        if (this.state.type === "3") {
            manualurl = `${this.props.url}../manual/manualsc.pdf`;
        } else if (this.state.type === "4") {
            manualurl = `${this.props.url}../manual/manualit.pdf`;
        }

        //If menu it's open
        let menuOpen = '';
        let menuIcon = <ArrowDropDown />;
        if (this.state.showMenu) {
            menuOpen = 'active';
            menuIcon = <ArrowDropUp />;
        }

        let a = new Date();
        let r = a.getDate();
        r = r + "" + a.getMonth() + "" + a.getHours() + "" + a.getMinutes();

        //If it's logged in we display the menu
        return (
            <header>
                <AppBar position="static" color="default">
                    <Toolbar>
                        {/*
                        <IconButton className="menu-button" color="inherit" aria-label="Menu" onClick={this.changeMenuStatus}>
                            <Menu />
                        </IconButton>
                        */}
                        <div className="tool-name">
                            GEOPOINT
                        </div>
                        <IconButton className="menu-button" color="inherit" aria-label="Menu" onClick={this.changeMenuStatus}>
                            <div className="user-name">{this.props.name}</div>
                            {menuIcon}
                        </IconButton>

                        <div className={`menu-drop ${menuOpen}`}>
                            <List>
                                <ListItem button selected={this.props.showRegions} onClick={() => { this.props.toggleRegions(); this.changeMenuStatus(); }}>
                                    <ListItemIcon>
                                        <NetworkCheck />
                                    </ListItemIcon>
                                    <ListItemText primary="Ubicación" />
                                </ListItem>

                                <Divider />
                                <ListItem onClick={this.handleAdicionalesClick}>
                                    <ListItemIcon>
                                        <Layers />
                                    </ListItemIcon>
                                    <ListItemText primary="Capas de Cobertura" />
                                    {this.state.openAdicionales ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                <Collapse in={this.state.openAdicionales} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding className="sub-menu">
                                        <ListItem button selected={this.props.showHFC}>
                                            <ListItemText inset primary="HFC" onClick={this.toggleHFC} />
                                        </ListItem>
                                        <ListItem button selected={this.props.showAdquirida}>
                                            <ListItemText inset primary="Adquirida" onClick={this.toggleAdquirida} />
                                        </ListItem>
                                        <ListItem button selected={this.props.showLTE}>
                                            <ListItemText inset primary="LTE Residencial" onClick={this.toggleLTE} />
                                        </ListItem>
                                        <ListItem button selected={this.props.showFTTH}>
                                            <ListItemText inset primary="FTTH Residencial" onClick={this.toggleFTTH} />
                                        </ListItem>
                                    </List>
                                </Collapse>

                                <Divider />

                                {
                                    (this.props.compact === "0") ?
                                        (
                                            <React.Fragment>
                                                <ListItem onClick={this.handleSearchClick}>
                                                    <ListItemIcon>
                                                        <Search />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Búsqueda" />
                                                    {this.state.openSearch ? <ExpandLess /> : <ExpandMore />}
                                                </ListItem>

                                                <Collapse in={this.state.openSearch} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding className="sub-menu">
                                                        <ListItem button selected={this.props.showSearch}>
                                                            <ListItemText inset primary="Dirección" onClick={() => { this.props.toggleSearch(); this.changeMenuStatus(); this.handleSearchClick(); }} />
                                                        </ListItem>
                                                        <ListItem button selected={this.props.showSearchBoxPoste}>
                                                            <ListItemText inset primary="Poste" onClick={() => { this.props.toggleSearchPoste(); this.changeMenuStatus(); this.handleSearchClick(); }} />
                                                        </ListItem>
                                                        <ListItem button selected={this.props.showSearchBoxCoordenadas}>
                                                            <ListItemText inset primary="Coordenadas" onClick={() => { this.props.toggleSearchCoordenadas(); this.changeMenuStatus(); this.handleSearchClick(); }} />
                                                        </ListItem>
                                                        <ListItem button selected={this.props.showSearchBoxNodo}>
                                                            <ListItemText inset primary="Nodo" onClick={() => { this.props.toggleSearchNodo(); this.changeMenuStatus(); this.handleSearchClick(); }} />
                                                        </ListItem>
                                                    </List>
                                                </Collapse>

                                                <Divider />
                                            </React.Fragment>
                                        ) : ""
                                }

                                <ListItem onClick={this.handleTiposClick}>
                                    <ListItemIcon>
                                        <Category />
                                    </ListItemIcon>
                                    <ListItemText primary="Tipo de Mapas" />
                                    {this.state.openTipos ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                <Collapse in={this.state.openTipos} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding className="sub-menu">
                                        <ListItem button onClick={() => this.changeMapType(1)} selected={this.props.mapType === 1}>
                                            <ListItemText inset primary="Open Street Map" />
                                        </ListItem>
                                        <ListItem button onClick={() => this.changeMapType(2)} selected={this.props.mapType === 2}>
                                            <ListItemText inset primary="Google" />
                                        </ListItem>
                                        <ListItem button onClick={() => this.changeMapType(3)} selected={this.props.mapType === 3}>
                                            <ListItemText inset primary="Google Satelital" />
                                        </ListItem>
                                        <ListItem button onClick={() => this.changeMapType(4)} selected={this.props.mapType === 4}>
                                            <ListItemText inset primary="Google Hybrido" />
                                        </ListItem>
                                    </List>
                                </Collapse>

                                <Divider />

                                {(this.props.type === "1" || this.props.type === "2") && 0 ? (
                                    <React.Fragment>
                                        <ListItem onClick={this.handleReportesClick}>
                                            <ListItemIcon>
                                                <Assessment />
                                            </ListItemIcon>
                                            <ListItemText primary="Reportes" />
                                            {this.state.openReportes ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={this.state.openReportes} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding className="sub-menu">
                                                <ListItem button>
                                                    <ListItemText inset primary="Descargar Nodos con Coordenadas" />
                                                </ListItem>
                                                <ListItem button>
                                                    <ListItemText inset primary="Registro de Clientes" />
                                                </ListItem>
                                                <ListItem button>
                                                    <ListItemText inset primary="Nodos Cargados" />
                                                </ListItem>
                                                <ListItem button>
                                                    <ListItemText inset primary="Control de Usuarios" />
                                                </ListItem>
                                            </List>
                                        </Collapse>

                                        <Divider />
                                    </React.Fragment>
                                ) : ""
                                }

                                <ListItem onClick={this.handleAyudaClick}>
                                    <ListItemIcon>
                                        <Help />
                                    </ListItemIcon>
                                    <ListItemText primary="Ayuda" />
                                    {this.state.openAyuda ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                <Collapse in={this.state.openAyuda} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding className="sub-menu">
                                        <ListItem button>
                                            <a href={`${manualurl}?v=${r}`} target="_blank">
                                                <ListItemText inset primary="Manual del usuario" />
                                            </a>
                                        </ListItem>
                                        {
                                            (this.props.compact === "0") ?
                                                (
                                                    <ListItem button>
                                                        <a href={`${this.props.url}../_uploads/colonias.xlsx?v=${r}`} target="_blank">
                                                            <ListItemText inset primary="Descargar Archivo de Colonias" />
                                                        </a>
                                                    </ListItem>
                                                ) : ""
                                        }
                                    </List>
                                </Collapse>
                                <React.Fragment>
                                    <Divider />

                                    <ListItem button onClick={() => { this.toggleCPModal(); this.changeMenuStatus(); }}>
                                        <ListItemIcon>
                                            <Security />
                                        </ListItemIcon>
                                        <ListItemText primary="Cambiar Contraseña" />
                                    </ListItem>

                                    <Divider />

                                    <ListItem button onClick={() => { this.props.logOut(); this.setState({ showMenu: false }); }}>
                                        <ListItemIcon>
                                            <ExitToApp />
                                        </ListItemIcon>
                                        <ListItemText primary="Salir" />
                                    </ListItem>
                                </React.Fragment>
                            </List>
                        </div>




                        <Snackbar
                            className="valid-user"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            open={this.state.open}
                            autoHideDuration={6000}
                            onClose={this.handleClose}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                                headlineMapping: {
                                    body1: "div",
                                    body2: "div"
                                }
                            }}
                            message={<span className='snackbar-content'><CheckCircle /> Su información ha sido enviada!</span>}
                            action={[
                                <IconButton
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className="close-snack"
                                    onClick={this.handleClose}
                                >
                                    <Close />
                                </IconButton>,
                            ]}
                        />

                        <Snackbar
                            className="valid-user"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            open={this.state.openCP}
                            autoHideDuration={6000}
                            onClose={this.handleCloseCP}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                                headlineMapping: {
                                    body1: "div",
                                    body2: "div"
                                }
                            }}
                            message={<span className='snackbar-content'><CheckCircle /> Su contraseña ha sido cambiada!</span>}
                            action={[
                                <IconButton
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className="close-snack"
                                    onClick={this.handleCloseCP}
                                >
                                    <Close />
                                </IconButton>,
                            ]}
                        />

                        <Snackbar
                            className="invalid-user"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            open={this.state.openError}
                            autoHideDuration={5000}
                            onClose={this.handleCloseError}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                                headlineMapping: {
                                    body1: "div",
                                    body2: "div"
                                }
                            }}
                            message={<span className='snackbar-content'><Error /> Debe de llenar todos campos!</span>}
                            action={[
                                <IconButton
                                    key="close"
                                    aria-label="Close"
                                    color="inherit"
                                    className="close-snack"
                                    onClick={this.handleCloseError}
                                >
                                    <Close />
                                </IconButton>,
                            ]}
                        />
                    </Toolbar>
                </AppBar>
                { /*}
                <Drawer open={this.state.showMenu} onClose={this.changeMenuStatus} className="main-drawer">
                    <div
                        tabIndex={0}
                        role="button"
                    >
                        <List>
                            <ListItem button selected={this.props.showRegions} onClick={() => { this.props.toggleRegions(); this.changeMenuStatus(); }}>
                                <ListItemIcon>
                                    <NetworkCheck />
                                </ListItemIcon>
                                <ListItemText primary="Cobertura" />
                            </ListItem>

                            <Divider />

                            <ListItem onClick={this.handleAdicionalesClick}>
                                <ListItemIcon>
                                    <Layers />
                                </ListItemIcon>
                                <ListItemText primary="Capas Adicionales" />
                                {this.state.openAdicionales ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={this.state.openAdicionales} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button selected={this.props.showAdquirida}>
                                        <ListItemText inset primary="Adquirida" onClick={this.toggleAdquirida} />
                                    </ListItem>
                                    <ListItem button selected={this.props.showLTE}>
                                        <ListItemText inset primary="LTE Residencial" onClick={this.toggleLTE} />
                                    </ListItem>
                                </List>
                            </Collapse>

                            <Divider />

                            <ListItem button selected={this.props.showSearch} onClick={() => { this.props.toggleSearch(); this.changeMenuStatus(); }}>
                                <ListItemIcon>
                                    <Search />
                                </ListItemIcon>
                                <ListItemText primary="Búsqueda" />
                            </ListItem>

                            <Divider />

                            <ListItem onClick={this.handleTiposClick}>
                                <ListItemIcon>
                                    <Category />
                                </ListItemIcon>
                                <ListItemText primary="Tipo de Mapas" />
                                {this.state.openTipos ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={this.state.openTipos} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button onClick={() => this.changeMapType(1)} selected={this.props.mapType === 1}>
                                        <ListItemText inset primary="Open Street Map" />
                                    </ListItem>
                                    <ListItem button onClick={() => this.changeMapType(2)} selected={this.props.mapType === 2}>
                                        <ListItemText inset primary="Google" />
                                    </ListItem>
                                    <ListItem button onClick={() => this.changeMapType(3)} selected={this.props.mapType === 3}>
                                        <ListItemText inset primary="Google Satelital" />
                                    </ListItem>
                                    <ListItem button onClick={() => this.changeMapType(4)} selected={this.props.mapType === 4}>
                                        <ListItemText inset primary="Google Hybrido" />
                                    </ListItem>
                                </List>
                            </Collapse>

                            <Divider />

                            {(this.props.type === "1" || this.props.type === "2") && 0 ? (
                                <React.Fragment>
                                    <ListItem onClick={this.handleReportesClick}>
                                        <ListItemIcon>
                                            <Assessment />
                                        </ListItemIcon>
                                        <ListItemText primary="Reportes" />
                                        {this.state.openReportes ? <ExpandLess /> : <ExpandMore />}
                                    </ListItem>
                                    <Collapse in={this.state.openReportes} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItem button>
                                                <ListItemText inset primary="Descargar Nodos con Coordenadas" />
                                            </ListItem>
                                            <ListItem button>
                                                <ListItemText inset primary="Registro de Clientes" />
                                            </ListItem>
                                            <ListItem button>
                                                <ListItemText inset primary="Nodos Cargados" />
                                            </ListItem>
                                            <ListItem button>
                                                <ListItemText inset primary="Control de Usuarios" />
                                            </ListItem>
                                        </List>
                                    </Collapse>

                                    <Divider />
                                </React.Fragment>
                            ) : ""
                            }

                            <ListItem onClick={this.handleAyudaClick}>
                                <ListItemIcon>
                                    <Help />
                                </ListItemIcon>
                                <ListItemText primary="Ayuda" />
                                {this.state.openAyuda ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={this.state.openAyuda} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button>
                                        <a href={manualurl} target="_blank">
                                            <ListItemText inset primary="Manual del usuario" />
                                        </a>
                                    </ListItem>
                                    <ListItem button>
                                        <a href={`${this.props.url}../_uploads/colonias.xlsx`} target="_blank">
                                            <ListItemText inset primary="Descargar Archivo de Colonias" />
                                        </a>
                                    </ListItem>
                                </List>
                            </Collapse>

                            <Divider />

                            <ListItem button onClick={() => { this.toggleCPModal(); this.changeMenuStatus(); }}>
                                <ListItemIcon>
                                    <Security />
                                </ListItemIcon>
                                <ListItemText primary="Cambiar Contraseña" />
                            </ListItem>

                            <Divider />

                            <ListItem button onClick={() => { this.props.logOut(); this.setState({ showMenu: false }); }}>
                                <ListItemIcon>
                                    <ExitToApp />
                                </ListItemIcon>
                                <ListItemText primary="Salir" />
                            </ListItem>
                        </List>
                    </div>
                </Drawer>
                        */}
                {modal}
                {modalCP}
                {modalFCP}
                <Button variant="fab" color="primary" className="send-data" onClick={this.toggleModal}>
                    <Icon><Announcement /></Icon>
                </Button>
            </header >
        );
    }
}
export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js